import { render } from "./InputComponent.vue?vue&type=template&id=5fd30cae"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__